export const appName = 'CleanTagger';